import ActionType from './../../constants';

const initialState = {
    List:[]
}

const RCadenaValor = (state = initialState, action:any ) => {
    switch(action.type){
        case ActionType.COMERCIO_LISTA_CADENA_VALOR_ADD: {
            return { 
                ...state,
                List: action.payload
            }
        }
        default:
            return state;
    }
}

export default RCadenaValor;